import React from "react";
import { Provider } from "react-redux";
import { Switch, Route, Redirect } from "react-router-dom";
import store from "./Redux/store";
import {
  getInspectionUserId,
  INSPECTION_BASE_PATH,
} from "./utils/authStorage";
import "./inspection.css";
import "./styles/damage-vehicle-guide.css";

import Login from "./Log in";
import UserCarList from "./User Car List";
import Car_Steps from "./Car_Steps";
import CarStepsDealer from "./Car_Steps_Dealer";
import Recoder from "./Car_Steps/recoder";
import CarUpdate from "./CarUpdate";
import Cardamagepage from "./Cardmagepage";
import ApiCall from "./ApiCall";
import CarDamge from "./Car Damge";
import CameraWithOverlayVideo from "./CameraWithOverlayVideo";

/**
 * Inspection staff app mounted under /inspection/* inside client-web.
 * Uses its own Redux store so it does not clash with the main client store.
 */
const InspectionHome = () =>
  getInspectionUserId() == null ? <Login /> : <UserCarList />;

/** All /inspection/* pages except login require an inspection session. */
const PrivateInspectionRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      getInspectionUserId() != null ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: INSPECTION_BASE_PATH,
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const InspectionApp = () => (
  <Provider store={store}>
    <div className="pi-inspection-app">
      <Switch>
        <Route exact path={INSPECTION_BASE_PATH} component={InspectionHome} />
        <Route
          exact
          path={`${INSPECTION_BASE_PATH}/`}
          component={InspectionHome}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/carsteps`}
          component={Car_Steps}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/dealerinspection`}
          component={CarStepsDealer}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/recordaudio`}
          component={Recoder}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/carupdate`}
          component={CarUpdate}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/cardamagepoint`}
          component={Cardamagepage}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/apicall`}
          component={ApiCall}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/damge`}
          component={CarDamge}
        />
        <PrivateInspectionRoute
          path={`${INSPECTION_BASE_PATH}/video`}
          component={CameraWithOverlayVideo}
        />
        <Redirect to={INSPECTION_BASE_PATH} />
      </Switch>
    </div>
  </Provider>
);

export default InspectionApp;
